import classnames from 'classnames';
import s from './index.module.scss';

import './index.css';
// Swiper modules
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

export const Slider = ({ slides, hideNavigation }) => {
    if (!slides.length) return null;

  return (
    <div className={classnames(s.wrapper, hideNavigation && s.hide_nav)}>
      <div className={s.container}>
        <Swiper
          autoHeight={true}
          spaceBetween={10}
          loop
          slidesPerView={1}
          className="dashboard_banner_slider"
          modules={[Pagination, Autoplay]}
          pagination={{
            clickable: true,
          }}
          autoplay={{
            delay: 3000, // 3 seconds
            disableOnInteraction: false,
          }}
        >
          {slides.map((slide, index) => (
            <SwiperSlide key={index}>{slide}</SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};
